import * as React from 'react';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from '@/lib/utils';

const RichRadioGroup = ({
  className,
  ref,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) => {
  return <RadioGroupPrimitive.Root className={cn('grid gap-4', className)} {...props} ref={ref} />;
};

const RichRadioItem = ({
  className,
  icon,
  title,
  description,
  badge,
  value,
  disabled,
  ref,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: string;
  badge?: React.ReactNode;
}) => {
  return (
    <div className="relative">
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          'group min-h-[74px] max-w-lg rounded-lg border bg-background px-4 pt-3.5 pb-4 transition-colors',
          'hover:bg-subtle',
          'data-disabled:cursor-not-allowed data-disabled:opacity-50',
          'data-[state=checked]:border-selected',
          'data-[state=checked]:bg-selected-soft',
          className
        )}
        value={value}
        disabled={disabled}
        {...props}
      >
        <div className="flex gap-3">
          <div
            className={cn(
              'mt-0.5 shrink-0 transition-colors',
              'group-data-[state=checked]:text-foreground',
              'group-data-[state=unchecked]:text-foreground',
              'group-data-disabled:text-muted-foreground'
            )}
          >
            {icon}
          </div>
          <div className="flex flex-col">
            <div
              className={cn(
                'text-left text-sm font-medium transition-colors',
                description && 'mb-1',
                'group-data-[state=checked]:text-foreground',
                'group-data-[state=unchecked]:text-foreground',
                'group-data-disabled:text-muted-foreground'
              )}
            >
              {title}
            </div>
            {description && (
              <p
                className={cn(
                  'text-left text-sm transition-colors',
                  'group-data-[state=checked]:text-foreground',
                  'group-data-[state=unchecked]:text-muted-foreground',
                  'group-data-disabled:text-muted-foreground'
                )}
              >
                {description}
              </p>
            )}
          </div>
        </div>
      </RadioGroupPrimitive.Item>
      {badge && <div className="absolute top-1 -right-2">{badge}</div>}
    </div>
  );
};

export { RichRadioGroup, RichRadioItem };
